var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{on:{"click":_vm.moveto}},[_vm._v("Continue")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }